// Interruptor manual de la decoración temática del sitio.
// Valores posibles: 'mundial' | 'navidad' | 'none'
//
// Cambiá esta única línea para prender/apagar o cambiar la decoración.
// (Por ahora solo está implementado 'mundial'; el resto quedan reservados.)
export const DECORACION = 'mundial';

// Cada cuánto sale el confetti desde el logo (en milisegundos).
// 90000 = 90 segundos. Subilo/bajalo a gusto.
export const CONFETTI_LOGO_INTERVAL_MS = 90000;
